var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"camera"},[_c('video',{staticClass:"feed",attrs:{"autoplay":"","playsinline":"","muted":""},domProps:{"muted":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }